module.exports = __webpack_public_path__ + "static/media/check-unselected.3a9bfcdd.svg";